


































































import {
  defineComponent,
  PropType,
  ref,
  computed,
  watch,
  useContext
} from '@nuxtjs/composition-api';
import { useTranslations } from '@vue-storefront/novulo';
import { addCurrency, priceFormat } from '~/helpers/utils';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export type ProductVariationType = {
  id: string;
  name: string;
  price: number;
  cashbackPrice: number | undefined;
  url: string;
  media?: string;
  alt?: string;
  secondHandCondition?: string;
  disabled: boolean;
};

export default defineComponent({
  name: 'ProductDropdown',
  props: {
    list: {
      type: Array as PropType<ProductVariationType[]>,
      default: () => [{ id: '', name: '', price: 0, url: '', media: '', disabled: false }]
    },
    selected: { type: String, default: '' },
    expanded: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const { i18n } = useContext();
    const { translate } = useTranslations();
    const formatUrl = useUrlFormatter();

    const selectedOption = ref(props.selected ?? '');
    const isShowingMore = ref(props.expanded);

    watch(
      () => props.expanded,
      val => {
        isShowingMore.value = val;
      }
    );

    const shownVariations = computed(() =>
      isShowingMore.value ? props.list : props.list.slice(0, 5)
    );

    const handleSelection = (item: ProductVariationType) => {
      selectedOption.value = item.id;
      emit('selected', item.id);
      if (item.url) window.location.href = formatUrl(item.url);
    };

    const expandList = () => {
      isShowingMore.value = true;
      emit('update:expanded', true);
    };

    const showSecondHandCondition = (item: ProductVariationType) =>
      Boolean(item && item.secondHandCondition);

    return {
      translate,
      addCurrency,
      priceFormat,
      formatUrl,
      shownVariations,
      isShowingMore,
      selectedOption,
      conditionLang: i18n?.locale,
      showSecondHandCondition,
      handleSelection,
      expandList
    };
  }
});
